import styled, { css } from 'styled-components';
interface ContainerStyledProps {
  isSelected: boolean;
}
export const ContainerStyled = styled.div<ContainerStyledProps>`
  ${({ theme }) =>
    css`
      cursor: pointer;
      &:hover {
        background-color: ${theme.colors.bechtel.blue[100]};
      }
    `}
  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: ${({ theme }) => theme.colors.blue[100]};
    `}
`;
